import React from "react";

import { Confirm } from "../features/auth";

const ConfirmPage = () => {
  return <Confirm />;
};

export default ConfirmPage;
